var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MatchMedia',{attrs:{"query":"(max-width: 768px)"},scopedSlots:_vm._u([{key:"default",fn:function({ matches }){return [(matches)?_c('LibraryMobile'):_c('LibraryDesktop')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }